<template>
  <div ui-view="" class="app-body" id="view">
    <page-header title="출입신청" description="출입신청요청을 합니다."/>
    <div class="page-body ph-30">
      <div class="sticky-holder" style="position: relative; height: auto;">
        <div class="control-group space-between sticky" style="left: 0px; top: 0px; z-index: 100; position: static;">
          <div style="width:100%">
            <ul class="nav nav-step">
              <!--<li class="checked">-->
              <li v-for="(item, index) in steps" :key="index" :class="[item.isSelect]">
                <i>{{item.id}}</i>{{item.name}}</li>
 
            </ul>
          </div>             
        </div>
      </div>
      <keep-alive>
        <router-view/>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import PageHeader from '../../layout/PageHeader.vue'
export default {
  components:{
    PageHeader
  },
  mounted(){
    this.init();
  },
  //{{$t('message.welcomeMessage')}}
  data(){
    return {
      steps: [
        {id: 0, name: this.$t('label.selectIdc'), routeName : 'selectIdc', isSelect: ''},
        {id: 1, name: this.$t('label.tosAgree'), routeName : 'agree', isSelect: ''},
        {id: 2, name: this.$t('label.inOutInput'), routeName : 'inputInfo', isSelect: ''},
        {id: 3, name: this.$t('label.inOutCheck'), routeName : 'checkInfo', isSelect: ''},
      ]
    }
  },
  methods: {
    init(){
      this.setStep();
    },  
    setStep(){
      var that = this;
      var selectIndex = 0;
      that.steps.forEach((item, index)=>{
        if(that.$route.name == item.routeName){
          item.isSelect = 'on';
          selectIndex = item.id
        } else{
          item.isSelect = '';
        }  
      })
      var checkedSteps = this.steps.slice(0, selectIndex);
      checkedSteps.forEach((x)=>{
        x.isSelect = 'checked';
      })
    }
  },
  watch: {
    $route (newVal) {
     this.setStep();
    },
  }
}
</script>

<style>

</style>